const PERCENT_SUFFIX = ' %';

export const formatFinancialProductPercentage = (value: number | string) =>
  `${value}${PERCENT_SUFFIX}`;
